import { createFileRoute } from '@tanstack/react-router'
import { generateLinks, generateMetaTags, routeSEO } from '@/lib/seo'

export const Route = createFileRoute('/dashboard')({
  head: () => ({
    meta: generateMetaTags(routeSEO['/dashboard']),
    links: generateLinks(routeSEO['/dashboard']),
  }),
})
